// Adds a seamless, slow newswire loop while preserving the original linked stories.
export default function ticker() {
    const track = document.querySelector('[data-ticker-track]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!track || reducedMotion.matches || track.children.length < 2) {
        return;
    }

    const originalItems = [...track.children];
    const cloneItems = originalItems.map((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        return clone;
    });

    track.append(...cloneItems);

    const setTickerDistance = () => {
        const firstClone = cloneItems[0];
        track.style.setProperty('--ticker-distance', `${firstClone.offsetLeft}px`);
    };

    setTickerDistance();
    window.addEventListener('resize', setTickerDistance, {passive: true});
}
